module.exports = __webpack_public_path__ + "img/vimeo.fae54f68.svg";